/**
 * @generated SignedSource<<3c7c0908140849c2dabcd171a7416a1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GraphQLImage_image$data = {
  readonly url: string;
  readonly " $fragmentType": "GraphQLImage_image";
};
export type GraphQLImage_image$key = {
  readonly " $data"?: GraphQLImage_image$data;
  readonly " $fragmentSpreads": FragmentRefs<"GraphQLImage_image">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GraphQLImage_image",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "6f77c6dfedb59ca62d4709b9156bdf17";

export default node;
